import { observer } from "mobx-react-lite"
import BlockBase from "./base"
import BlockState from "pages/scheme-editor/store/block"
import BlockInfo from "./base-info"
import { useLayoutEffect } from "react"
import InputBlock from "components/controls/input-block"

const BlockGroup = observer(({ state }: { state: BlockState }) => {

  useLayoutEffect(() => {
    state.setEmitters([ "Группа" ])
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <BlockBase state={state}>
      <BlockInfo state={state}>
        <InputBlock sx={{ my: 1 }} {...state.dataProps('changeSlug')} label="Поменять slug схемы" placeholder="Пустое значение"/>
      </BlockInfo>
    </BlockBase>
  )
})

export default BlockGroup